
import "../Foundation/stylable/colors.st.css.js";
import "../Foundation/stylable/shadows.st.css.js";
import "../Text/Text.st.css.js";
import "../Text/Caption.st.css.js";

import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_209_0_CounterBadge";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_209_0_CounterBadge__root","text":"wds_1_209_0_CounterBadge__text","caption":"wds_1_209_0_CounterBadge__caption","numberContent":"wds_1_209_0_CounterBadge__numberContent"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-counter-badge-border-radius-medium":"--wds-counter-badge-border-radius-medium","wds-counter-badge-padding-horizontal-small":"--wds-counter-badge-padding-horizontal-small","wds-counter-badge-padding-horizontal-medium":"--wds-counter-badge-padding-horizontal-medium","wds-color-text-standard-primary-light":"--wds-color-text-standard-primary-light","wds-color-text-standard-secondary":"--wds-color-text-standard-secondary","wds-color-fill-dark-primary":"--wds-color-fill-dark-primary","wds-color-fill-standard-primary":"--wds-color-fill-standard-primary","wds-color-fill-standard-secondary":"--wds-color-fill-standard-secondary","wds-color-text-standard-primary":"--wds-color-text-standard-primary","wds-color-fill-destructive-primary":"--wds-color-fill-destructive-primary","wds-color-fill-warning-primary":"--wds-color-fill-warning-primary","wds-color-yellow-400":"--wds-color-yellow-400","wds-color-fill-urgent-primary":"--wds-color-fill-urgent-primary","wds-color-fill-success-primary":"--wds-color-fill-success-primary","wds-color-fill-dark-tertiary":"--wds-color-fill-dark-tertiary","wds-color-fill-dark-secondary":"--wds-color-fill-dark-secondary","wds-shadow-surface-raised":"--wds-shadow-surface-raised"}; 




